<template>
    <div>
        <form method="POST" action="/admin/statistics/orders/excel">
            <input type="hidden" name="_token" value="" id="orders_form_token">
            <div class="row">
                <div class="col-md-9">
                    <h3>Выборка заказов</h3>
                    <date-range-picker></date-range-picker>
                    <div class="form-group clearfix"><div class="col-md-12"><strong>или</strong></div></div>
                    <orders-checker></orders-checker>
                    <div class="b-orders-statistics__filters-container">
                        <ul class="nav nav-tabs b-admin-form__tabs">
                            <li role="presentation" class="active">
                                <a href="#data" aria-controls="data" role="tab" data-toggle="tab">
                                    Выгружаемые данные <i class="fa"></i>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="#statuses" aria-controls="statuses" role="tab" data-toggle="tab">
                                    Статусы <i class="fa"></i>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="#pay_types" aria-controls="pay_types" role="tab" data-toggle="tab">
                                    Способы оплаты <i class="fa"></i>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="#domains" aria-controls="domains" role="tab" data-toggle="tab">
                                    Домены <i class="fa"></i>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="#sellers" aria-controls="sellers" role="tab" data-toggle="tab">
                                    Продавцы <i class="fa"></i>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane active" id="data">
                                <h3>Показать следующие данные: </h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_all_columns" @change="selectAllColumns()" type="checkbox">
                                            Выбрать всё
                                        </label>
                                    </div>
                                    <div v-for="column in columns" class="col-md-3">
                                        <label>
                                            <input type="checkbox" v-model="chosen_columns" :value="column.code">
                                            {{column.title}}
                                        </label>
                                    </div>
                                    <div v-for="column in chosen_columns">
                                        <input
                                                type="hidden"
                                                :name="'columns[' + findColumnName(column) + ']'"
                                                :value="column"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" class="tab-pane" id="statuses">
                                <h3>Выбрать заказы в статусах: </h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_all_statuses" @change="selectAllStatuses()" type="checkbox">
                                            Выбрать всё
                                        </label>
                                    </div>
                                    <div v-for="status in statuses" class="col-md-3">
                                        <label>
                                            <input
                                                    type="checkbox"
                                                    v-model="chosen_statuses"
                                                    :name="'statuses[' + status.code + ']'"
                                                    :value="status.code"
                                            >
                                            {{status.title}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" class="tab-pane" id="pay_types">
                                <h3>Выбрать заказы с оплатой: </h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_all_payment_types" @change="selectAllPaymentTypes()" type="checkbox">
                                            Выбрать всё
                                        </label>
                                    </div>
                                    <div v-for="payment_type in payment_types" class="col-md-3">
                                        <label>
                                            <input
                                                    type="checkbox"
                                                    name="payment_types[]"
                                                    v-model="chosen_payment_types"
                                                    :value="payment_type.code"
                                            >
                                            {{payment_type.title}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" class="tab-pane" id="domains">
                                <h3>Выбрать заказы с доменов: </h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_all_domains" @change="selectAllDomains()" type="checkbox">
                                            Выбрать всё
                                        </label>
                                    </div>
                                    <div v-for="domain in domains" class="col-md-3">
                                        <label>
                                            <input
                                                    type="checkbox"
                                                    name="domains[]"
                                                    v-model="chosen_domains"
                                                    :value="domain.code"
                                            >
                                            {{domain.title}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" class="tab-pane" id="sellers">
                                <h3>Выбрать заказы по продовцам:</h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_no_sellers" type="checkbox" name="no_sellers" :value="is_chosen_no_sellers">
                                            Заказы без продавцов
                                        </label>
                                    </div>
                                    <div class="col-md-12">
                                        <label style="font-size: 15px">
                                            <input v-model="is_chosen_all_sellers" @change="selectAllSellers()" type="checkbox">
                                            Выбрать всё
                                        </label>
                                    </div>
                                    <div v-for="seller in sellers" class="col-md-3">
                                        <label>
                                            <input
                                                    type="checkbox"
                                                    name="sellers[]"
                                                    v-model="chosen_sellers"
                                                    :value="seller.code"
                                            >
                                            {{seller.title}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <button class="btn btn-primary form-control" @click="load">
                            <span v-show="!show_loader">Выгрузить данные</span>
                            <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        </button>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-success form-control">
                            <i class="fa fa-file-excel-o"></i>
                            Сохранить в Excel
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <statistics-counting
                :data="orders"
                :data_for_counting="data_for_counting"
        ></statistics-counting>
        <div class="col-md-12" v-show="orders.length > 0">
            <h3>Всего заказов: {{ orders.length }}</h3>
        </div>
        <div class="row" v-if="orders.length > 0">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th v-for="column in chosen_columns">{{findColumnName(column)}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, key) in orders">
                        <td><b>{{ key + 1 }}.</b></td>
                        <td v-for="column in chosen_columns">{{order[column]}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['statuses', 'payment_types', 'domains', 'sellers'],
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        document.querySelector('#orders_form_token').value = document.querySelector('#token').getAttribute('content');
    },
    data: function () {
        let columns = [
            { code: 'order_number', title: 'Номер заказа' },
            { code: 'purchase_price', title: 'Цена закупки (€)' },
            { code: 'order_items_price', title: 'Сумма товаров' },
            { code: 'discount', title: 'Скидка' },
            { code: 'discounted_order_items_price', title: 'Сумма с учётом скидки' },
            { code: 'payment_tax', title: 'Комиссия' },
            { code: 'delivery_tax', title: 'Доставка' },
            { code: 'total_price', title: 'Итоговая сумма' },
            { code: 'payment_type', title: 'Способ оплаты' },
            { code: 'track', title: 'Почтовый идентификатор' },
            { code: 'customer_name', title: 'ФИО покупателя' },
            { code: 'address', title: 'Адрес доставки' },
            { code: 'created_at', title: 'Дата заказа' },
            { code: 'status', title: 'Статус заказа' },
            { code: 'status_change_time', title: 'Дата получения выбранного статуса' },
            { code: 'profit', title: 'Прибыль' },
            { code: 'margin', title: 'Маржа' },
            { code: 'domain', title: 'Магазин' },
        ];

        /**
         * types: total or average
         */
        let data_for_counting = [
            {
                type: 'total',
                name: 'Общая сумма с учетом скидок',
                append_to_result: 'руб.',
                column_code: 'discounted_order_items_price',
            },
            {
                type: 'average',
                name: 'Средняя цена заказа (без доставки и страховки)',
                append_to_result: 'руб.',
                column_code: 'discounted_order_items_price',
            },
        ];

        return {
            orders: [],
            date_start: '',
            date_finish: '',
            order_params: '',
            columns: columns,
            data_for_counting: data_for_counting,
            chosen_columns: this.getCodes(columns),
            chosen_domains: this.getCodes(this.domains),
            chosen_statuses: this.getCodes(this.statuses),
            chosen_sellers: this.getCodes(this.sellers),
            chosen_payment_types: this.getCodes(this.payment_types),

            // Bool
            show_loader: false,
            is_chosen_all_columns: true,
            is_chosen_all_domains: true,
            is_chosen_all_statuses: true,
            is_chosen_all_payment_types: true,
            is_chosen_all_sellers: true,
            is_chosen_no_sellers: true,
        };
    },
    methods: {
        load: function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }
            this.show_loader = true;

            let data = {
                columns: this.chosen_columns,
                statuses: this.chosen_statuses,
                sellers: this.chosen_sellers,
                no_sellers: this.is_chosen_no_sellers,
                payment_types: this.chosen_payment_types,
                domains: this.chosen_domains
            };

            if(!!(this.date_start && this.date_finish)) {
                data.date_start = this.date_start;
                data.date_finish = this.date_finish;
            }

            if(this.order_params.length) {
                data.order_params = this.order_params;
            }

            this.$http.post(
                '/statistics/orders/get', data
            ).then(function (response) {
                this.show_loader = false;

                this.orders = response.data;
            }, function (response) {
                this.show_loader = false;

                let errors = '';
                for (let field in response.data) {
                    errors += response.data[field] + '\r\n';
                }

                alert(errors);
            });
        },
        getCodes: function (arr) {
            let codes = [];

            arr.forEach(function (item) {
                codes.push(item.code);
            });

            return codes;
        },
        findColumnName: function (code) {
            return this.columns.find(function (item) {
                return item.code === code;
            }).title;
        },
        checkEnteredData: function () {
            return !!(
                (this.date_start && this.date_finish || this.order_params.length)
                && this.chosen_statuses.length
                && this.chosen_payment_types.length
                && this.chosen_domains.length
            );
        },
        selectAllColumns: function () {
            this.is_chosen_all_columns ? this.chosen_columns = this.getCodes(this.columns) : this.chosen_columns = [];
        },
        selectAllStatuses: function () {
            this.is_chosen_all_statuses ? this.chosen_statuses = this.getCodes(this.statuses) : this.chosen_statuses = [];
        },
        selectAllPaymentTypes: function () {
            this.is_chosen_all_payment_types ? this.chosen_payment_types = this.getCodes(this.payment_types) : this.chosen_payment_types = [];
        },
        selectAllDomains: function () {
            this.is_chosen_all_domains ? this.chosen_domains = this.getCodes(this.domains) : this.chosen_domains = [];
        },
        selectAllSellers: function () {
            this.is_chosen_all_sellers ? this.chosen_sellers = this.getCodes(this.sellers) : this.chosen_sellers = [];
        }
    },
    created: function () {
        this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
        this.$root.$on('update:order_params', (val) => { this.order_params = val; });
    }
};
</script>
